import React from 'react';

import { CargoSelectionType, SelectionCustomCargoParameters } from '../types';

export const DEFAULT_SELECTION_CARGO_PARAMETERS_STATE: SelectionCustomCargoParameters[] = [
  {
    customCargoType: 'base',
    parametersCargoCalcType: 'volume',
    baseParameters: {
      quantity: 1,
      length: '1',
      width: '1',
      height: '1',
      weight: '10',
    },
    palletParameters: {
      type: '0',
      quantity: 1,
      normativeHeightOfStacking: '1',
      weight: 10000,
    },
    volumeParameters: {
      volume: '1',
      weight: '10',
    },
  },
];

export const SELECTION_CARGO_TITLE: Record<CargoSelectionType, React.ReactNode> = {
  fcl: 'FCL',
  ftl: 'FTL',
  fclFtl: (
    <div style={{ display: 'inline-flex', gap: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <span>FCL</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <svg
          className={'replace'}
          width="16"
          height="16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={'#9199AA'}
            d="M4.4 7.6l-.8.8L.1 4.9a.5.5 0 010-.8L3.6.6l.8.8L1.7 4H16v1H1.7l2.7 2.6zM0 11h14.3l-2.7-2.6.8-.8 3.5 3.5c.1.2.1.6 0 .8l-3.5 3.5-.8-.8 2.7-2.6H0v-1z"
          />
        </svg>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <span>FTL</span>
      </div>
    </div>
  ),
};
